import type { RequiredGeneric } from '@pba/utils';
import type { ComponentProps, Key } from 'react';
import { EmptyInput } from 'ui';
import type { EmailSelectedUserWithRole, RegisteredSelectedUserWithRole } from '../../types';
import type { CommonFormValues } from '../event-form-modal';
import type { InviteesType } from '../EventInvitees';
import { EventInviteesSelect } from './event-invitees-select';

type Configuration<FormValues extends CommonFormValues = never> = {
  key: Key;
} & ComponentProps<typeof EventInviteesSelect<FormValues>>;

type P<FormValues extends CommonFormValues = never> = {
  allowedInvitees?: InviteesType[];
  selects: Array<Configuration<FormValues>>;
};

const defaultAllowedInvitees: InviteesType[] = ['registered', 'email'];

const EventInviteesSelects = <FormValues extends CommonFormValues = never>({
  allowedInvitees = defaultAllowedInvitees,
  selects,
}: RequiredGeneric<FormValues, P<FormValues>>) => (
  <>
    {allowedInvitees.includes('registered') ? <EmptyInput<RegisteredSelectedUserWithRole[]> name="invitees" /> : null}
    {allowedInvitees.includes('email') ? <EmptyInput<EmailSelectedUserWithRole[]> name="emailInvitees" /> : null}

    {selects.map((configuration) => (
      <EventInviteesSelect<CommonFormValues> {...configuration} key={configuration.key} />
    ))}
  </>
);

export default EventInviteesSelects;
